import { render, staticRenderFns } from "./EventSuper.vue?vue&type=template&id=836a78d0&scoped=true"
import script from "./EventSuper.vue?vue&type=script&lang=js"
export * from "./EventSuper.vue?vue&type=script&lang=js"
import style0 from "./EventSuper.vue?vue&type=style&index=0&id=836a78d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836a78d0",
  null
  
)

export default component.exports